import { Box, Paper, Typography } from "@mui/material";
import DOMPurify from "dompurify";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { DocumentoVersao, ISdocumentoVersao } from "../../../types/documento/versao/DocumentoVersao";
import { useGetDocumentoVersaoQuery } from "./documentoVersaoApiSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { DocumentoInternoViewMenu } from "../documentoView/DocumentoInternoViewMenu";
import PrintButtonRascunho from "../../../components/formControls/PrintButtonRascunho";


export const DocumentoEditarView = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [documentoVersao, setDocumentoVersao] = useState<DocumentoVersao>(ISdocumentoVersao);
  const { idEdicao } = useParams(); 
  const { id } = useParams(); //idDocumento

  const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);

  useEffect(() => {
    if (!processoSelecionado) {
      alert("Nenhum processo selecionado");
      window.location.href = "/processo/lista";  // Ajuste para o seu URL correto
    }
  }, [processoSelecionado]);

  const { data, isFetching, error } = useGetDocumentoVersaoQuery(idEdicao || "");
  
  useEffect(() => {
    if (data) {
      setDocumentoVersao(data);
    } else if (error) {
      enqueueSnackbar("Registro não encontrado!", { variant: "error" });
      window.location.href = "/processo/lista";  // Ajuste para o seu URL correto
    } else if (isFetching) {
      enqueueSnackbar("Buscando registro...", { variant: "info" });
    }
  }, [data, error, isFetching, enqueueSnackbar]);

  return (
    <Box sx={{ padding: 1 }}>
      <Box p={1}>
        <DocumentoInternoViewMenu documento={id as string} />
      </Box>
      
      <Box p={1}>        
        <PrintButtonRascunho conteudo={documentoVersao.conteudo} />
      </Box>

      <Paper
        elevation={3}
        sx={{
          padding: 2,
          backgroundColor: "#f5f5f5",
          borderRadius: 2,
          boxShadow: 3,
          overflow: "hidden",
          wordWrap: "break-word",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <Box id="conteudo" mt={2}>
          <Typography
            variant="subtitle1"
            component="div"
            textAlign="justify"
            style={{ fontSize: "1.0rem" }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(documentoVersao.conteudo),
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};
